import lockr from 'lockr';

const { API_URL, AUTH_KEY } = require('../constants').default;

/**
 * Uploaded files are not served directly from /files/ any more; they go through the
 * authenticated API endpoint. <script> tags and createjs asset loads cannot send an
 * Authorization header, so the token is passed as the access-token query param.
 *
 * @param {string} relativePath Path inside the uploads folder, e.g. "comics/1/2/name/name.js"
 * @returns {string}
 */
export function authenticatedFileUrl(relativePath) {
    const path = String(relativePath).replace(/^\/+/, '');
    const authKey = lockr.get(AUTH_KEY);
    const token = authKey ? `&access-token=${encodeURIComponent(authKey)}` : '';
    return `${API_URL}file/serve?path=${encodeURIComponent(path)}${token}`;
}

/**
 * Make an uploaded-file URL loadable by an <img>, <a> or <script>:
 *  - API file URLs (".../api/file/serve?path=...") get the access-token added
 *  - legacy direct uploads URLs (".../files/comics/...") are converted to API file URLs
 * Any other URL (data:, external, public files, already tokenised) is returned unchanged.
 *
 * @param {string} url
 * @returns {string}
 */
export function toAuthenticatedFileUrl(url) {
    if (typeof url !== 'string' || url.indexOf('access-token=') !== -1) {
        return url;
    }
    if (url.indexOf('/file/serve?') !== -1) {
        const authKey = lockr.get(AUTH_KEY);
        return authKey ? `${url}&access-token=${encodeURIComponent(authKey)}` : url;
    }
    const match = url.match(/^(?:https?:\/\/[^/]+)?\/files\/([^?#]+)/);
    return match ? authenticatedFileUrl(decodeURIComponent(match[1])) : url;
}
